<template>
  <span
    v-if="!badge"
    class="feather-icon"
    v-html="svg"
  />
  <span
    v-else
    class="feather-icon feather-icon-badge position-relative"
  >
    <span v-html="svg" />
    <span
      class="badge badge-up badge-pill"
      :class="badgeClasses"
    >{{ badge }}</span>
  </span>
</template>

<script>
import feather from 'feather-icons'

export default {
  name: 'FeatherIcon',
  props: {
    icon: { type: [String, Object], required: true },
    size: { type: String, default: '14' },
    badge: { type: [String, Object, Number], default: null },
    badgeClasses: { type: [String, Object, Array], default: 'badge-primary' },
  },
  computed: {
    svg() {
      // "UserIcon" -> "user"
      const name = String(this.icon)
        .replace(/Icon$/, '')
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .toLowerCase()
      const entry = feather.icons[name]
      return entry ? entry.toSvg({ width: this.size, height: this.size }) : ''
    },
  },
}
</script>

<style lang="scss">
svg.feather {
  outline: none;
}

// inline-flex: alinea el svg y conserva los margenes del span.
.feather-icon {
  display: inline-flex;
  align-items: center;
}
</style>
